import { useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { isEmpty } from "lodash";
import DeleteConfirmationModal from "../../components/organisms/AppModals/DeleteConfirmationModal";
import { deleteUserRole, selectUserRoles } from "./index";
import classNames from "classnames";
import {
  menuDeleteIcon,
  menuDuplicateIcon,
  menuEditIcon,
  usersIcon,
} from "../../assets/icons";
import { PopOver } from "../../components/atoms";
import { POPOVER_BUTTONS, ROUTES } from "../../constants";
import { EmptyLayout, SearchBar, Table } from "../../components/molecules";
import { actions as userActions } from "./users.reducers";
import { actions as modalActions } from "../../components/organisms/Modal/modal.reducers";
import { MODALS } from "../../components/organisms/AppModals/modals.constants";
import { SPINNER_NAMES } from "../../components/organisms/Spinner/spinner.constants";

const { DELETE, DUPLICATE, EDIT } = POPOVER_BUTTONS;
const { USERS,INVITATIONS } = ROUTES;
const { DELETE_MODAL, MANAGE_USER_ROLE_MODAL } = MODALS;
const { setSelectedModal, setItemToBeDeleted } = modalActions;
const { setSelectedUserRole } = userActions;
const { DELETE_USER_ROLES } = SPINNER_NAMES;

const UserRoles = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const userRolesData = useSelector(selectUserRoles);

  const [shouldShowDeleteModal, setShouldShowDeleteModal] = useState(false);

  const popOverOptions = (row) => [
    {
      name: EDIT,
      icon: menuEditIcon,
      handleOnClick: () => {
        dispatch(setSelectedModal(MANAGE_USER_ROLE_MODAL));
        dispatch(setSelectedUserRole(row));
      },
    },
    {
      name: DUPLICATE,
      icon: menuDuplicateIcon,
      handleOnClick: () => console.log("Clicked on Duplicate option."),
    },
    {
      name: DELETE,
      icon: menuDeleteIcon,
      classes: "border-t border-gray-600",
      handleOnClick: () => {
        dispatch(setSelectedModal(DELETE_MODAL));
        dispatch(setItemToBeDeleted(row));
        setShouldShowDeleteModal(true);
      },
    },
  ];

  const handleDeleteUserRole = useCallback(
    (user) => {
      dispatch(deleteUserRole(user.id)).then((res) => {
        if (res.payload) {
          dispatch(setItemToBeDeleted(null));
          dispatch(setSelectedModal(null));
          setShouldShowDeleteModal(false);
        }
      });
    },
    [dispatch]
  );

  const handleOnClick = useCallback(() => {
    dispatch(setSelectedModal(MANAGE_USER_ROLE_MODAL));
  }, [dispatch]);

  const buttonFormatter = (row) => (
    <div onClick={(e) => e.stopPropagation()}>
      <PopOver
        options={popOverOptions(row)}
        classes="right-full -bottom-3"
        data={row}
      />
    </div>
  );

  const columns = [
    {
      dataField: "name",
      text: "User Role",
    },
    {
      dataField: "usercount",
      text: "User Count",
      width: 150,
    },
    {
      formatter: buttonFormatter,
      width: 70,
    },
  ];

  const handleOnRowClick = (row) => {
    dispatch(setSelectedModal(MANAGE_USER_ROLE_MODAL));
    dispatch(setSelectedUserRole(row));
  };

  const renderUserRoles = () =>
    userRolesData.length ? (
      <Table columns={columns} data={userRolesData} onRowClick={handleOnRowClick} />
    ) : (
      <EmptyLayout
        title="No User Role"
        subTitle="You can get started by creating a new user role."
        buttonText="Create New User Role"
        image={usersIcon}
        handleOnClick={handleOnClick}
      />
    );

  return (
    <div className="content overflow-auto flex-1">
      <Helmet>
        <title>User Roles | TavaJS</title>
      </Helmet>
      <div className="flex gap-6 flex-row items-center border-b border-gray-800 px-6 py-4 text-gray-400">
        <button
          className="rounded-lg py-2 px-4 hover:bg-gray-800 hover:text-gray-50 text-sm font-medium cursor-pointer"
          onClick={() => navigate(USERS)}
        >
          <span>Users</span>
        </button>
        <button
          className="rounded-lg py-2 px-4 hover:bg-gray-800 text-sm font-medium hover:text-white cursor-pointer"
          onClick={() => navigate(INVITATIONS)}
        >
         Invitations
        </button>
        <button className="rounded-lg py-2 px-4 text-sm font-medium bg-gray-800 text-gray-50">
          <span>User Roles</span>
        </button>
      </div>
      <div className="p-6 w-full">
      <div className={classNames("flex-col xs:flex-row flex justify-end mb-4 gap-4",{"justify-between": !isEmpty(userRolesData)})}>
          {!isEmpty(userRolesData) && (
            <SearchBar placeholder="Search" handleOnSearch={() => {}} />
          )}
          <button
            type="button"
            className="btn btn-primary w-full xs:w-auto"
            onClick={() => dispatch(setSelectedModal(MANAGE_USER_ROLE_MODAL))}
          >
            Create New User Role
          </button>
        </div>
        {renderUserRoles()}
        {shouldShowDeleteModal && (
          <DeleteConfirmationModal
            handleDelete={handleDeleteUserRole}
            setShouldShowDeleteModal={setShouldShowDeleteModal}
            spinner={DELETE_USER_ROLES}
          />
        )}
      </div>
    </div>
  );
};
export default UserRoles;
